export const HOME_BLUEPRINT_TEMPLATE = 'home_blueprint';

export const HOME_BLUEPRINT_SECTIONS = [
  { type: 'hero', label: 'Hero' },
  { type: 'heroMosquito', label: 'Header mit Muecken', defaultEnabled: false },
  { type: 'bundles', label: 'Bundles' },
  { type: 'problem', label: 'Problem' },
  { type: 'trustBar', label: 'Trustbar' },
  { type: 'benefits', label: 'Vorteile' },
  { type: 'empathy', label: 'Empathy' },
  { type: 'promise', label: 'Promise' },
  { type: 'products', label: 'Produkte' },
  { type: 'typeCompare', label: 'Vergleich' },
  { type: 'lifestyle', label: 'Lifestyle' },
  { type: 'werkwijze', label: 'Ablauf' },
  { type: 'comparison', label: 'Vorher/Nachher' },
  { type: 'sample', label: 'Beratung' },
  { type: 'sampleKit', label: 'Musterkit' },
  { type: 'bigQuote', label: 'Zitat' },
  { type: 'reviews', label: 'Reviews' },
  { type: 'about', label: 'Ueber uns' },
  { type: 'trustDeep', label: 'Vertrauen' },
  { type: 'leadForm', label: 'Leadformular' },
  { type: 'faq', label: 'FAQ' },
  { type: 'finalCta', label: 'Finale CTA' },
];

const SECTION_BY_TYPE = Object.fromEntries(HOME_BLUEPRINT_SECTIONS.map((section) => [section.type, section]));

export function createHomeBlueprintSections() {
  return HOME_BLUEPRINT_SECTIONS.map((section, index) => ({
    id: `${section.type}-${index + 1}`,
    type: section.type,
    enabled: section.defaultEnabled !== false,
  }));
}

export function normalizeBlueprintSections(sections) {
  if (!Array.isArray(sections) || sections.length === 0) return createHomeBlueprintSections();
  const seen = new Set();
  const normal = sections
    .map((section, index) => {
      const type = typeof section === 'string' ? section : section?.type;
      if (!type || !SECTION_BY_TYPE[type] || seen.has(type)) return null;
      seen.add(type);
      return {
        id: section?.id || `${type}-${index + 1}`,
        type,
        enabled: section?.enabled !== false,
      };
    })
    .filter(Boolean);

  for (const section of HOME_BLUEPRINT_SECTIONS) {
    if (!seen.has(section.type)) {
      const missingSection = {
        id: `${section.type}-${normal.length + 1}`,
        type: section.type,
        enabled: section.defaultEnabled !== false,
      };

      if (section.type === 'heroMosquito') {
        const heroIndex = normal.findIndex((item) => item.type === 'hero');
        normal.splice(heroIndex >= 0 ? heroIndex + 1 : 0, 0, missingSection);
      } else {
        normal.push(missingSection);
      }
    }
  }
  return normal;
}

export function getBlueprintSectionLabel(type) {
  return SECTION_BY_TYPE[type]?.label || type;
}

export function createHomeBlueprintPage(seed = {}) {
  const id = seed.id || `page-${Date.now()}`;
  return {
    id,
    path: seed.path || '/neue-landingspage',
    template: HOME_BLUEPRINT_TEMPLATE,
    published: false,
    translations: {
      nl: {
        title: seed.nlTitle || 'Nieuwe landingspagina',
        eyebrow: 'Horrenmaker',
        excerpt: '',
        body: '',
      },
      de: {
        title: seed.deTitle || 'Neue Landingpage',
        eyebrow: 'Horrenmaker',
        excerpt: '',
        body: '',
      },
    },
    seo: {
      nl: { title: '', description: '', image: '', noindex: true },
      de: { title: '', description: '', image: '', noindex: true },
    },
    sections: createHomeBlueprintSections(),
    sectionOverrides: {
      hero: {
        nl: {
          eyebrow: 'Horrenmaker',
          h1: ['Nieuwe landingspagina', 'op maat gemaakt'],
          sub: 'Gebruik deze startpagina-template als basis voor een sterke nieuwe SEO- of productpagina.',
        },
        de: {
          eyebrow: 'Horrenmaker',
          h1: ['Neue Landingpage', 'auf Startseiten-Niveau'],
          sub: 'Nutze diese Startseiten-Vorlage als Basis fuer eine starke neue SEO- oder Produktseite.',
        },
      },
    },
  };
}
